import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// React
import React, { useContext, useEffect, useState } from 'react';

// mui
import { Grid, Typography, Box, Checkbox, Link } from '@mui/material';

// context
import { ConsentDetailsContextV1 } from '../context/consentContextV1';
import { ConsentDetailsContextV2 } from '../context/consentContextV2';
import { CompanyDetailsContext } from '../context/companyContext';

// libs
import i18n from '../i18n';

// interface

// configurations
import { legalDocTypeIdConstants, roles, tenantMapping } from '../configurations/settings';

// utils
import { getStorageLinks, isEmpty } from '../utils/util';

// components
import SalesPermissionSection from './salesPermissionSection';
var ConsentAcceptanceSection = function ConsentAcceptanceSection(props) {
  var environment = props !== null && props !== void 0 && props.environment ? props === null || props === void 0 ? void 0 : props.environment : 'development';
  var _useContext = useContext(ConsentDetailsContextV1),
    consentDataV1 = _useContext.consentDataV1;
  var _useContext2 = useContext(ConsentDetailsContextV2),
    consentDataV2 = _useContext2.consentDataV2;
  var _useContext3 = useContext(CompanyDetailsContext),
    companyData = _useContext3.companyData;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    consentArray = _useState2[0],
    setConsentArray = _useState2[1];
  var consentArrayState = [];
  var handleConsentArray = function handleConsentArray(accepted, docName, docTypeId, docUrl, displayLabel) {
    var tempConsentArray = {
      accepted: false,
      documentName: '',
      documentTypeId: '',
      documentUrl: '',
      displayName: ''
    };
    tempConsentArray.accepted = accepted;
    tempConsentArray.documentName = docName;
    tempConsentArray.documentTypeId = docTypeId;
    tempConsentArray.documentUrl = docUrl;
    tempConsentArray.displayName = displayLabel;
    return tempConsentArray;
  };
  useEffect(function () {
    if ((props === null || props === void 0 ? void 0 : props.role) === roles.BUYER_ROLE && consentDataV1) {
      consentDataV1 === null || consentDataV1 === void 0 || consentDataV1.forEach(function (consentItem1) {
        switch (consentItem1.agreementTypeId) {
          case legalDocTypeIdConstants.privacyPolicy:
            consentArrayState.push(handleConsentArray(companyData === null || companyData === void 0 ? void 0 : companyData.userConsent, consentItem1.documentName, consentItem1.agreementTypeId, getStorageLinks(environment).cdn + '/' + "user-agreement-docs/privacy-policy/" + consentItem1.version + '/' + (props === null || props === void 0 ? void 0 : props.countryCode) + '/' + consentItem1.documentName, i18n.t('REGISTRATION.DATA_POLICY')));
            break;
          case legalDocTypeIdConstants.termsCondition:
            consentArrayState.push(handleConsentArray(companyData === null || companyData === void 0 ? void 0 : companyData.userConsent, consentItem1.documentName, consentItem1.agreementTypeId, getStorageLinks(environment).cdn + '/' + "user-agreement-docs/terms-conditions/" + consentItem1.version + '/' + (props === null || props === void 0 ? void 0 : props.countryCode) + '/' + consentItem1.documentName, i18n.t('REGISTRATION.TERMS_CONDITIONS_TEXT')));
            break;
          default:
            break;
        }
      });
      setConsentArray(consentArrayState);
      props === null || props === void 0 || props.setConsentCheck(consentArrayState);
    }
    if ((props === null || props === void 0 ? void 0 : props.role) === roles.SELLER_ROLE && consentDataV1 && consentDataV2) {
      var _consentDataV2$filter;
      consentDataV2 === null || consentDataV2 === void 0 || (_consentDataV2$filter = consentDataV2.filter(function (userAgreement) {
        return userAgreement.isUserConcentNeeded;
      })) === null || _consentDataV2$filter === void 0 || _consentDataV2$filter.forEach(function (consentItem2) {
        var _tenantMapping$filter;
        consentArrayState.push(handleConsentArray(companyData === null || companyData === void 0 ? void 0 : companyData.userConsent, consentItem2.documentName, consentItem2.documentTypeId, consentItem2.blobFileUrl, ((_tenantMapping$filter = tenantMapping.filter(function (data) {
          return data.tenant === consentItem2.marketplaceName;
        })[0]) === null || _tenantMapping$filter === void 0 ? void 0 : _tenantMapping$filter.marketplaceName) + ' ' + i18n.t('REGISTRATION.MARKETPLACE') + ' '));
      });
      consentDataV1 === null || consentDataV1 === void 0 || consentDataV1.filter(function (item) {
        return item.agreementTypeId === legalDocTypeIdConstants.privacyPolicy;
      }).forEach(function (consentItem1) {
        if (consentItem1.agreementTypeId === legalDocTypeIdConstants.privacyPolicy || consentItem1.agreementTypeId === legalDocTypeIdConstants.termsCondition) {
          consentArrayState.push(handleConsentArray(companyData === null || companyData === void 0 ? void 0 : companyData.userConsent, consentItem1.documentName, consentItem1.agreementTypeId, getStorageLinks(environment, props === null || props === void 0 ? void 0 : props.role).azure + "user-agreement-docs/".concat(props === null || props === void 0 ? void 0 : props.regionCode, "/v1/data-protection-policy.pdf"), i18n.t('REGISTRATION.DATA_POLICY')));
        }
      });
      setConsentArray(consentArrayState);
      props === null || props === void 0 || props.setConsentCheck(consentArrayState);
    }
  }, [consentDataV1, consentDataV2]);
  useEffect(function () {
    var _props$consentSection;
    if (props !== null && props !== void 0 && props.consentSection && (props === null || props === void 0 || (_props$consentSection = props.consentSection) === null || _props$consentSection === void 0 ? void 0 : _props$consentSection.length) > 0) {
      setConsentArray(props === null || props === void 0 ? void 0 : props.consentSection);
      props === null || props === void 0 || props.setConsentCheck(props === null || props === void 0 ? void 0 : props.consentSection);
    }
  }, [props === null || props === void 0 ? void 0 : props.consentSection]);
  var handleChange = function handleChange(name) {
    var tempConsentCheckedArray = _toConsumableArray(consentArray);
    tempConsentCheckedArray === null || tempConsentCheckedArray === void 0 || tempConsentCheckedArray.forEach(function (item) {
      if (item.displayName === name && !item.accepted) item.accepted = true;else if (item.displayName === name && item.accepted) item.accepted = false;
    });
    setConsentArray(tempConsentCheckedArray);
    props === null || props === void 0 || props.setConsentCheck(tempConsentCheckedArray);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.role) === roles.SELLER_ROLE && isEmpty(props === null || props === void 0 ? void 0 : props.dynamicForm) && /*#__PURE__*/React.createElement(SalesPermissionSection, {
    environment: props !== null && props !== void 0 && props.environment ? props === null || props === void 0 ? void 0 : props.environment : 'development',
    axiosInstance: props === null || props === void 0 ? void 0 : props.axiosInstance,
    clientToken: props === null || props === void 0 ? void 0 : props.clientToken,
    dcsJwtToken: props === null || props === void 0 ? void 0 : props.dcsJwtToken,
    requestorPayload: props === null || props === void 0 ? void 0 : props.requestorPayload,
    role: props === null || props === void 0 ? void 0 : props.role,
    setLoader: props === null || props === void 0 ? void 0 : props.setLoader
  }), /*#__PURE__*/React.createElement(Box, null, (consentArray === null || consentArray === void 0 ? void 0 : consentArray.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h6",
    my: 1,
    sx: {
      marginTop: '18px !important',
      marginBottom: '0 !important',
      fontWeight: 'bold'
    }
  }, i18n.t('REGISTRATION.TERMS_SECTION_HEADING'))), consentArray === null || consentArray === void 0 ? void 0 : consentArray.map(function (consentItem) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: consentItem.documentTypeId
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 1,
      xs: 2,
      md: 0.5,
      lg: 0.5,
      xl: 0.5
    }, /*#__PURE__*/React.createElement(Checkbox, {
      "data-testid": "agree-terms",
      checkedIcon: /*#__PURE__*/React.createElement(Box, {
        component: "img",
        src: getStorageLinks(environment).cdn + '/assets/img/cb-checked.svg'
      }),
      icon: /*#__PURE__*/React.createElement(Box, {
        component: "img",
        src: getStorageLinks(environment).cdn + '/assets/img/cb-unchecked.svg'
      }),
      disableFocusRipple: true,
      disableRipple: true,
      disableTouchRipple: true,
      onChange: function onChange() {
        return handleChange(consentItem.displayName);
      },
      checked: consentItem.accepted
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sm: 10,
      xs: 10,
      md: 11,
      lg: 11,
      xl: 11
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        marginTop: '6px'
      }
    }, i18n.t('REGISTRATION.READ_AGREE_TEXT'), ' ', consentItem.documentTypeId === legalDocTypeIdConstants.privacyPolicy || props.role === roles.BUYER_ROLE ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      target: "_blank",
      sx: {
        textDecoration: 'none'
      },
      href: consentItem.documentUrl
    }, consentItem.displayName)) : /*#__PURE__*/React.createElement(React.Fragment, null, consentItem.displayName, ' ', /*#__PURE__*/React.createElement(Link, {
      target: "_blank",
      sx: {
        textDecoration: 'none'
      },
      href: consentItem.documentUrl
    }, i18n.t('REGISTRATION.TERMS_CONDITIONS_TEXT')))))));
  })));
};
export default ConsentAcceptanceSection;